import React from "react"
import LoanAccountingForm from './Form'

export default function LoanAccountingDetails() {
  return <LoanAccountingForm isUpdate={ false } />
}



// WEBPACK FOOTER //
// ./src/components/Accounting/LoanAccounting/Details.js